<template>
  <a-modal
    width="auto"
    centered
    v-model:open="loginModalVisible"
    @cancel="$emit('close'), (loginQrState = false)"
    :maskStyle="{
      'background-color':
        document.documentElement.offsetWidth > 600 ? '' : 'rgba(0, 0, 0, 0)',
    }"
    :maskClosable="false"
  >
    <div class="register50">
      <img
        style="width: 100%"
        :src="`https://img.cyuai.com/cpn/material/a53afeee6a4447a5b041b9b3e9bf3ea1.png?${dayjs().format(
          'YYYYMMDDHH'
        )}`"
        alt="img"
      />
    </div>
    <!-- 二维码登录 -->
    <div
      class="scanCodes"
      @click="
        loginType == 2 || loginType == 3
          ? ((loginType = 0), (loginForm.sms_code = ''), (loginQrState = false))
          : userLoginQrFun()
      "
    >
      <svg
        style="padding: 5px 0"
        v-if="loginType == 2 || loginType == 3"
        t="1722506080572"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="9708"
        width="60"
        height="60"
      >
        <path
          d="M848.770567 892.10619c0 18.29371-3.645949 35.372103-11.001811 51.107252-7.355862 15.735149-17.398214 29.679305-30.191018 41.768505-12.792804 12.0892-27.824349 21.619839-45.03067 28.591917-17.206321 6.972078-35.691923 10.426135-55.456806 10.426135L316.973702 1024c-19.764882 0-38.250484-3.454057-55.456806-10.426135-17.206321-6.972078-32.237866-16.502717-45.03067-28.591917-12.792804-12.0892-22.899119-26.033356-30.191018-41.768505-7.291898-15.735149-11.001811-32.749578-11.001811-51.107252l0-759.188956c0-18.29371 3.645949-35.500031 11.001811-51.618964 7.355862-16.118933 17.398214-30.191018 30.191018-42.280217 12.792804-12.0892 27.824349-21.619839 45.03067-28.591917C278.723218 3.454057 297.20882 0 316.973702 0l390.052595 0c19.764882 0 38.250484 3.454057 55.456806 10.426135 17.206321 6.972078 32.237866 16.502717 45.03067 28.591917 12.792804 12.0892 22.899119 26.161284 30.191018 42.280217 7.355862 16.118933 11.001811 33.325255 11.001811 51.618964L848.706603 892.10619 848.770567 892.10619zM759.796614 185.687551 263.115997 185.687551l0 652.624898 496.616653 0L759.796614 185.687551 759.796614 185.687551zM511.424324 869.079143c-15.351365 0-28.719845 5.500906-40.105441 16.502717-11.385596 11.001811-17.014429 24.562184-17.014429 40.681117 0 15.415329 5.692798 28.719845 17.014429 40.105441 11.385596 11.385596 24.690112 17.014429 40.105441 17.014429 16.118933 0 29.679305-5.692798 40.681117-17.014429 11.001811-11.385596 16.502717-24.690112 16.502717-40.105441 0-16.118933-5.500906-29.679305-16.502717-40.681117C541.103629 874.516085 527.543257 869.079143 511.424324 869.079143L511.424324 869.079143zM599.374852 92.236117c0-5.88469-1.854957-10.426135-5.500906-13.752264-3.645949-3.326129-7.675682-4.92523-12.0892-4.92523L442.215254 73.558623c-3.645949 0-7.48379 1.663065-11.513524 4.92523C426.671997 81.809982 424.625148 86.415391 424.625148 92.236117c0 5.88469 1.854957 10.426135 5.500906 13.752264 3.645949 3.326129 7.675682 4.92523 12.0892 4.92523l139.569492 0c4.413517 0 8.443251-1.663065 12.0892-4.92523C597.519895 102.726217 599.374852 98.120807 599.374852 92.236117L599.374852 92.236117z"
          fill="#000000"
          p-id="9709"
        ></path>
      </svg>
      <svg
        v-else
        t="1721642317869"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="81677"
        width="60"
        height="60"
      >
        <path
          d="M544 896h64v64h-64v-64zM416 416V64H64v352h64v64h64v-64h224z m-288-64V128h224v224H128z"
          p-id="81678"
          fill="#000000"
        ></path>
        <path
          d="M192 192h96v96h-96v-96zM608 64v352h352V64H608z m288 288H672V128h224v224z"
          p-id="81679"
          fill="#000000"
        ></path>
        <path
          d="M736 192h96v96h-96v-96zM192 736h96v96h-96v-96zM64 480h64v64H64v-64zM192 480h64v64h-64v-64z"
          p-id="81680"
          fill="#000000"
        ></path>
        <path
          d="M256 608H64v352h352V608h-96v-64h-64v64z m96 64v224H128V672h224zM480 96h64v96h-64V96zM480 256h64v64h-64v-64zM672 480H544v-96h-64v96H320v64h288v64h64v-64zM672 608h64v64h-64v-64zM480 608h64v96h-64v-96zM480 768h64v128h-64V768zM608 704h64v192h-64V704zM800 608h160v64H800v-64zM896 480h64v64h-64v-64zM736 480h128v64H736v-64zM736 704h64v64h-64v-64zM896 768h-32v64h64v-64h32v-64h-64zM736 832h64v64h-64v-64zM800 896h160v64H800v-64z"
          p-id="81681"
          fill="#000000"
        ></path>
      </svg>
    </div>
    <div class="login">
      <div class="login_card">
        <!-- 切换登录 -->
        <div
          class="head-btn pointer"
          v-if="loginType == 0"
          @click="(loginType = 1), (loginForm.username = loginForm.mobile)"
        >
          切换密码登录
        </div>
        <div
          class="head-btn pointer"
          v-else-if="loginType == 1"
          @click="(loginType = 0), (loginForm.mobile = loginForm.username)"
        >
          切换验证码登录
        </div>
        <div class="head-btn" v-else></div>
        <!-- 标题 -->
        <div class="title">
          {{
            loginType == 0
              ? "短信验证码登录"
              : loginType == 1
              ? "账号密码登录"
              : loginType == 2
              ? "微信扫码登录"
              : loginType == 3
              ? "绑定手机号"
              : "登录"
          }}
        </div>
        <!-- 提示 -->
        <div class="tip">
          {{
            loginType == 2
              ? "关注后自动登录"
              : loginType == 3
              ? "绑定后下次可直接扫码登录"
              : "未注册用户将自动登录注册"
          }}
        </div>
        <a-form :model="loginForm" class="login_form">
          <!-- 手机号 -->
          <div
            class="login_form_item"
            v-if="loginType === 0 || loginType === 3"
          >
            <div class="label">手机号</div>
            <div>
              <a-input
                v-model:value="loginForm.mobile"
                class="login_input"
                placeholder="输入您的手机号码"
                @keyup.enter="submitLogin()"
              />
            </div>
          </div>
          <!-- 验证码 -->
          <div
            class="login_form_item"
            v-if="loginType === 0 || loginType === 3"
          >
            <div class="label">验证码</div>
            <div class="verification_code">
              <a-input
                v-model:value="loginForm.sms_code"
                class="login_input"
                placeholder="输入验证码"
                maxlength="4"
                @keyup.enter="submitLogin()"
                ref="smsCode"
                @change="
                  () => {
                    if (loginForm.sms_code.length >= 4) {
                      submitLogin();
                    }
                  }
                "
              />
              <div class="sms_btn">
                <a-button
                  class="button_login newButtonDark"
                  @click="getVerifycode"
                >
                  {{ smsCodeTxt }}
                </a-button>
              </div>
            </div>
          </div>
          <!-- 账号 -->
          <div class="login_form_item" v-if="loginType === 1">
            <div class="label">账号</div>
            <div>
              <a-input
                v-model:value="loginForm.username"
                class="login_input"
                placeholder="输入您的账号或手机号码"
                @keyup.enter="submitLogin()"
              />
            </div>
          </div>
          <!-- 密码 -->
          <div class="login_form_item" v-if="loginType === 1">
            <div class="label">密码</div>
            <div>
              <a-input
                v-model:value="loginForm.password"
                class="login_input"
                placeholder="请输入密码"
                maxlength="32"
                type="password"
                @keyup.enter="submitLogin()"
                ref="password"
              />
            </div>
          </div>

          <!-- 登录按钮 -->
          <div
            class="login_Button"
            v-if="loginType === 0 || loginType == 1 || loginType === 3"
          >
            <a-button
              class="button_login newButtonDark"
              @click="submitLogin"
              :loading="submitLoading"
            >
              {{ loginType == 3 ? "绑定" : "登录" }}
            </a-button>
          </div>
        </a-form>
        <!-- 扫码 -->
        <div class="login_QR" v-if="loginType == 2">
          <img
            v-if="userLoginQrData.qr_code_url"
            class="img"
            :src="userLoginQrData.qr_code_url"
            @click="userLoginQrFun()"
          />
          <LoadingOutlined v-else style="font-size: 20px" />
          <div
            v-if="this.userLoginQrData.pastDueState"
            class="QR_masking"
            @click="userLoginQrFun()"
          >
            <div>已失效</div>
            <div>点击刷新</div>
          </div>
        </div>
        <div class="constract-text">
          登录即视为同意
          <span
            @click="mixinOpenNewWindow(`${http_Docs}/agreement`)"
            class="pointer"
          >
            《<span style="text-decoration: underline">用户服务协议</span>》
          </span>
          、
          <span
            @click="mixinOpenNewWindow(`${http_Docs}/privacy`)"
            class="pointer"
          >
            《<span style="text-decoration: underline">隐私政策</span>》
          </span>
          、
          <span @click="mixinOpenNewWindow(http_Docs)" class="pointer">
            《<span style="text-decoration: underline">授权许可协议</span>》
          </span>
        </div>
      </div>
    </div>
    <template #footer></template>
    <!-- 图像确认框 -->
    <a-modal
      class="slideCaptchaModal newFooter"
      :destroyOnClose="true"
      centered
      v-model:open="imgConfirmVisible"
      title="图形验证"
      :footer="null"
    >
      <SlideCaptcha
        @slideCaptchaCall="slideCaptchaCall"
        :mobile="loginForm.mobile"
        :mould="2"
      ></SlideCaptcha>
    </a-modal>
  </a-modal>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useHomeStore } from "../store";
import { LoadingOutlined } from "@ant-design/icons-vue";
import SlideCaptcha from "@/components/slideCaptcha";
export default {
  components: { LoadingOutlined, SlideCaptcha },
  name: "login",
  data() {
    return {
      document: document, // 页面文档
      loginModalVisible: true,
      // 登录完成后重定向地址
      redirect: null,
      loginType: 0, // 0验证码 1密码 2扫码 3扫码后绑定手机号
      userLoginQrData: {},
      loginQrState: false, // 二维码等待中
      loginForm: {
        mobile: "", // 15090669190
        sms_code: "", // 1234
        username: "",
        password: "",
      },
      smsCodeTxt: "获取验证码",

      submitLoading: false,
      QrSetTimeout: null,
      ScanSetTimeout: null,

      // 验证图像验证码
      imgConfirmVisible: false,
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true, // 这样初始化的时候也会触发
      deep: true, // 它会进行深度监听
    },
  },
  props: {},
  created() {
    this.userLoginQrFun();
  },
  mounted() {
    console.log("login页面 mounted");
  },
  computed: {
    ...mapState(useHomeStore, ["token", "user"]),
  },
  methods: {
    ...mapActions(useHomeStore, ["changeToken", "changeUser"]),
    // 请求微信登陆二维码
    userLoginQrFun() {
      this.loginType = 2;
      this.userLoginQrData = {};

      this.$http
        .POST(this.$manageUrl.userLoginQr, {})
        .then((res) => {
          if (res) {
            console.log(res);
            this.userLoginQrData = res.result;

            this.userLoginQrData.time = new Date(); // 倒计时开始时间
            this.loginQrState = true; // 登陆中

            this.countDown();
            this.userLoginScanFun();
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message.error(error.msg || error.message || "ERROR");
        });
    },
    // 二维码有效期
    countDown() {
      clearTimeout(this.QrSetTimeout);
      this.QrSetTimeout = null;

      if (
        this.userLoginQrData.qr_code_url &&
        // 必须不是过期状态，已经过期了就没必要继续刷新一次了
        !this.userLoginQrData.pastDueState &&
        this.loginQrState
      ) {
        // console.log(
        //   (new Date().getTime() - this.userLoginQrData.time.getTime()) / 1000
        // );
        if (
          (new Date().getTime() - this.userLoginQrData.time.getTime()) / 1000 >=
          this.userLoginQrData.qr_expire_seconds
        ) {
          this.userLoginQrData.pastDueState = true;
        } else {
          this.QrSetTimeout = setTimeout(() => {
            this.countDown();
          }, 1000);
        }
      }
    },
    // 登录微信验证
    userLoginScanFun() {
      clearTimeout(this.ScanSetTimeout);
      this.ScanSetTimeout = null;

      if (
        this.userLoginQrData.qr_code_url &&
        !this.userLoginQrData.pastDueState &&
        // 防止临近成功的时候点击了取消，这时既然取消了即便登录成功了也不应该更新用户信息
        this.loginQrState
      ) {
        this.$http
          .POST(this.$manageUrl.userLoginScan, {
            ticket: this.userLoginQrData.qr_ticket,
          })
          .then((res) => {
            if (res.result.token) {
              console.log(res);

              this.loginQrState = false; // 登录结束
              this.userInfoGet(res);
            }
          })
          .catch((error) => {
            console.log(error);
            if (error.code == 6) {
              console.log("去绑定手机号");
              this.$message.error(error.msg || error.message || "ERROR");

              this.loginType = 3;
              this.loginQrState = false; // 登录结束
            }
          })
          .finally(() => {
            if (this.loginQrState) {
              this.ScanSetTimeout = setTimeout(() => {
                this.userLoginScanFun();
              }, 2000);
            }
          });
      }
    },
    // 点击登录
    submitLogin() {
      let formData = this.loginForm;
      let msg = "";
      if (this.loginType === 0 || this.loginType == 3) {
        if (!formData.mobile) {
          msg = "请输入手机号码";
        } else if (!formData.sms_code) {
          msg = "请输入短信验证码";
          this.$refs["smsCode"].focus();
        }
      } else if (this.loginType === 1) {
        if (!formData.username) {
          msg = "请输入账号";
        } else if (!formData.password) {
          msg = "请输入密码";
          this.$refs["password"].focus();
        }
      }
      if (msg) {
        this.$message.warning(msg);
        return;
      } else {
        if (this.loginType === 0) {
          this.smsLogin(formData);
        } else if (this.loginType === 1) {
          this.login(formData);
        } else if (this.loginType == 3) {
          this.qrBindMobileFun();
        }
      }
      // console.log(formData);
    },
    // 0   短信登录
    smsLogin(formData) {
      this.submitLoading = true;
      let data = formData;
      this.$http
        .POST(this.$manageUrl.loginsms, data)
        .then((res) => {
          if (res) {
            this.submitLoading = false;
            this.userInfoGet(res);
          }
        })
        .catch((error) => {
          console.log(error);
          this.submitLoading = false;
          this.$message.error(error.msg || error.message || "ERROR");
        });
    },
    // 1   密码登录
    login(formData) {
      this.submitLoading = true;
      let data = formData;
      this.$http
        .POST(this.$manageUrl.login, data)
        .then((res) => {
          if (res) {
            this.submitLoading = false;
            this.userInfoGet(res);
          }
        })
        .catch((error) => {
          console.log(error);
          this.submitLoading = false;
          this.$message.error(error.msg || error.message || "ERROR");
        });
    },
    // 3   绑定手机号
    qrBindMobileFun() {
      this.submitLoading = true;
      this.$http
        .POST(this.$manageUrl.loginsms, {
          ...this.loginForm,
          ticket: this.userLoginQrData.qr_ticket,
        })
        .then((res) => {
          if (res) {
            this.submitLoading = false;
            this.userInfoGet(res);
          }
        })
        .catch((error) => {
          console.log(error);
          this.submitLoading = false;
          this.$message.error(error.msg || error.message || "ERROR");
        });
    },
    // 更新存储存储userInfo
    userInfoGet(res) {
      this.changeToken(res.result.token);
      // this.changeUser(res.result.user);

      this.$message.success(res.msg);
      this.$emit("close");
      this.getInfo().then((e) => {
        if (e) {
          if (this.redirect) {
            this.$router.push(this.redirect);
          } else {
            this.$router.push("/");
          }
        }
      });
    },
    // 请求图片验证码
    getVerifycode() {
      if (this.smsCodeTxt == "获取验证码") {
        let msgText = "";
        if (!this.loginForm.mobile) {
          msgText = "请输入手机号码";
        } else if (
          this.loginForm.mobile &&
          this.loginForm.mobile.length != 11
        ) {
          msgText = "手机号码位数不正确";
        }
        if (msgText != "") {
          this.$message.warning(msgText);
          return;
        }

        this.imgConfirmVisible = true;
      }
    },
    // 请求验证码
    slideCaptchaCall() {
      this.daoshu();
      this.imgConfirmVisible = false;
    },
    // 倒计时
    daoshu() {
      if (this.smsCodeTxt == "获取验证码") {
        this.smsCodeTxt = 60;
        setTimeout(this.daoshu, 1000);
      } else if (this.smsCodeTxt <= 1) {
        this.smsCodeTxt = "获取验证码";
      } else {
        this.smsCodeTxt = this.smsCodeTxt - 1;
        setTimeout(this.daoshu, 1000);
      }
    },
  },
};
</script>

<style lang="scss">
@media (max-width: 600px) {
  .slideCaptchaModal {
    .ant-modal-content {
      padding: 10px !important;
    }
  }
}
</style>
<style lang="scss" scoped>
@media (max-width: 600px) {
  .register50 {
    display: none !important;
  }
}
// 广告50
.register50 {
  width: 100%;
  height: 188px;
  position: absolute;
  top: -188px;
  left: 0;
  display: flex;
  align-items: flex-end;
}
// 二维码登录
.scanCodes {
  width: 60px;
  height: 60px;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
  z-index: 1;

  &::before {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    background: linear-gradient(
      -45deg,
      rgb(255, 255, 255) 30%,
      rgb(255, 255, 255, 0) 30%
    );
  }
}
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  // overflow: overlay;

  .login_card {
    position: relative;
    width: 430px;
    padding: 10px 0;
    border-radius: 5px;
    box-sizing: border-box;
    // 切换
    .head-btn {
      width: 95%;
      height: 20px;
      line-height: 20px;
      text-align: end;
      color: #000000;
      font-size: 13px;
      margin-bottom: 10px;
    }
    // 标题
    .title {
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      color: #000000;
      line-height: 18px;
    }
    // 提示
    .tip {
      font-size: 12px;
      color: #000000;
      margin-top: 12px;
      line-height: 12px;
      text-align: center;
    }
    // 按钮
    .button_login {
      height: 52px;
    }
    // 登录框
    .login_form {
      // 信息输入
      .login_form_item {
        .label {
          font-size: 14px;
          line-height: 14px;
          margin: 20px 0 12px 0;
          color: #000000;
        }
        // 输入框
        .login_input {
          width: 100%;
          height: 52px !important;
        }
        // 特殊验证码，短框
        .verification_code {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .sms_btn {
            display: inline-block;
            margin-left: 12px;
            .button_login {
              width: 100px;
              padding: 0px !important;
            }
          }
        }
      }
      // 登录按钮
      .login_Button {
        margin-top: 40px;
        width: 100%;
        .button_login {
          width: 100%;
        }
      }
    }
    // 扫码登录
    .login_QR {
      margin-top: 20px;
      // height: 176px;
      height: calc(156px + 20px + 92px);
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      position: relative;
      img {
        height: 100%;
        cursor: pointer;
      }
      .QR_masking {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.8);
        backdrop-filter: blur(3px); // 模糊
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        line-height: 1.2;
        cursor: pointer;
      }
    }
    // 协议
    .constract-text {
      width: 100%;
      text-align: center;
      color: rgb(113 113 122);
      font-size: 12px;
      margin-top: 20px;
    }
  }
}
</style>